module.exports = __webpack_public_path__ + "img/cat-multi.59328088.jpg";